export class TagModel {
  id = null;
  name = '';
  color: string = '';
}
